import "./Header.scss";
import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
   faBed,
   faCalendarDays,
   faCar,
   faPerson,
   faPlane,
   faTaxi,
} from "@fortawesome/free-solid-svg-icons";
import { DateRange } from "react-date-range";
import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css"; // theme css file
import { format } from "date-fns";
import { useNavigate } from "react-router-dom";

export const Header = ({ type }) => {
   const [destination, setDestination] = useState("");
   const [openDate, setOpenDate] = useState(false);

   const [date, setDate] = useState([
      {
         startDate: new Date(),
         endDate: new Date(),
         key: "selection",
      },
   ]);

   const [openOptions, setOpenOptions] = useState(false);

   const [options, setOptions] = useState({
      adult: 1,
      children: 0,
      room: 1,
   });

   const handelOption = (name, operation) => {
      setOptions((prev) => {
         return {
            ...prev,
            [name]:
               operation === "increase" ? options[name] + 1 : options[name] - 1,
         };
      });
   };

   const navigate = useNavigate();

   const handelSearch = () => {
      navigate("/hotel", { state: { destination, date, options } });
   };

   return (
      <div className="header">
         <div
            className={
               type === "list" ? "headerContainer listMode" : "headerContainer"
            }
         >
            <div className="headerList">
               <div className="headerListItem active">
                  <FontAwesomeIcon icon={faBed} />
                  <span>Stays</span>
               </div>

               <div className="headerListItem">
                  <FontAwesomeIcon icon={faPlane} />
                  <span>Flights</span>
               </div>

               <div className="headerListItem">
                  <FontAwesomeIcon icon={faCar} />
                  <span>Car rentals</span>
               </div>

               <div className="headerListItem">
                  <FontAwesomeIcon icon={faBed} />
                  <span>Attractions</span>
               </div>

               <div className="headerListItem">
                  <FontAwesomeIcon icon={faTaxi} />
                  <span>Airport taxis</span>
               </div>
            </div>

            {type !== "list" && (
               <>
                  <h1 className="headerTitle">
                     Ein Leben lang Rabatte? Einfach Genius!
                  </h1>
                  <p className="headerDesc">
                     Werden Sie für Ihre Reisen belohnt – mit einem kostenlosen
                     Booking.com-Konto können Sie sofort 10% oder mehr sparen.
                  </p>
                  <button className="headerBtn">Sign In</button>
                  <div className="headerSearch">
                     <div className="headerSearchItem">
                        <FontAwesomeIcon icon={faBed} className="headerIcon" />
                        <input
                           type="text"
                           placeholder="Where are you heading?"
                           className="headerSearchInput"
                           onChange={(e) => setDestination(e.target.value)}
                        />
                     </div>

                     <div className="headerSearchItem">
                        <FontAwesomeIcon icon={faCalendarDays} />
                        <span
                           onClick={() => setOpenDate(!openDate)}
                           className="headerSearchText"
                        >
                           {`${format(
                              date[0].startDate,
                              "MM/dd/yyyy"
                           )} to ${format(date[0].startDate, "MM/dd/yyyy")} `}
                        </span>
                        {openDate && (
                           <DateRange
                              editableDateInputs={true}
                              onChange={(item) => setDate([item.selection])}
                              moveRangeOnFirstSelection={false}
                              ranges={date}
                              className="date"
                              minDate={new Date()}
                           />
                        )}
                     </div>

                     <div className="headerSearchItem">
                        <FontAwesomeIcon icon={faPerson} />
                        <span
                           onClick={() => setOpenOptions(!openOptions)}
                           className="headerSearchText"
                        >
                           {`${options.adult} adult . ${options.children} children . ${options.room} room`}{" "}
                        </span>

                        {openOptions && (
                           <div className="options">
                              <div className="optionItem">
                                 <span className="optionText">Adult</span>

                                 <div className="optionCounter">
                                    <button
                                       disabled={options.adult <= 1}
                                       className="optionCounterBtn"
                                       onClick={() =>
                                          handelOption("adult", "decrease")
                                       }
                                    >
                                       -
                                    </button>
                                    <span className="optionCounterNumber">
                                       {options.adult}
                                    </span>
                                    <button
                                       className="optionCounterBtn"
                                       onClick={() =>
                                          handelOption("adult", "increase")
                                       }
                                    >
                                       +
                                    </button>
                                 </div>
                              </div>

                              <div className="optionItem">
                                 <span className="optionText">Children</span>
                                 <div className="optionCounter">
                                    <button
                                       disabled={options.children <= 0}
                                       className="optionCounterBtn"
                                       onClick={() =>
                                          handelOption("children", "decrease")
                                       }
                                    >
                                       -
                                    </button>
                                    <span className="optionCounterNumber">
                                       {options.children}
                                    </span>
                                    <button
                                       className="optionCounterBtn"
                                       onClick={() =>
                                          handelOption("children", "increase")
                                       }
                                    >
                                       +
                                    </button>
                                 </div>
                              </div>

                              <div className="optionItem">
                                 <span className="optionText">Room</span>
                                 <div className="optionCounter">
                                    <button
                                       disabled={options.room <= 1}
                                       className="optionCounterBtn"
                                       onClick={() =>
                                          handelOption("room", "decrease")
                                       }
                                    >
                                       -
                                    </button>
                                    <span className="optionCounterNumber">
                                       {options.room}
                                    </span>
                                    <button
                                       className="optionCounterBtn"
                                       onClick={() =>
                                          handelOption("room", "increase")
                                       }
                                    >
                                       +
                                    </button>
                                 </div>
                              </div>
                           </div>
                        )}
                     </div>

                     <div className="headerSearchItem">
                        <button className="headerBtn" onClick={handelSearch}>
                           Search
                        </button>
                     </div>
                  </div>
               </>
            )}
         </div>
      </div>
   );
};

export default Header;
